/* eslint-ignore */
// @ts-nocheck
import React, { Component } from 'react';
import { Formik, Form, Field as FormikField } from 'formik';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { IoMdArrowBack, IoMdArrowForward } from 'react-icons/io';
import api from '~/services/api';
import ContainedButton from '~/components/layout/form/containedButton';
import OutlinedButton from '~/components/layout/form/outlinedButton';

import {
  toggleStep,
  registerContactName,
} from '~/store/actions/singup-actions';
import StyledButton from '~/components/layout/button';
import { SelectPhoneContainer, FormBox, FormHeader } from './styles';
import { arrUniqueContact } from '~/utils/functions';

class SignupComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phones: [],
      checkedId: null,
      contactSelected: null,
      offset: 0,
      loading: true,
    };
  }

  componentDidMount() {
    this.requestGetPhones();
  }

  handleContactChange = (contact, contactId) => {
    this.setState({ checkedId: contactId, contactSelected: contact });
  };

  selectedContact = (contact, contactId) => {
    if (!this.state.loading) {
      if ((contact, contactId)) {
        this.props.dispatch(registerContactName(contact, contactId));
        this.sendSmsCode();
      } else {
        this.props.dispatch(toggleStep(4));
      }
    }
  };

  requestGetPhones = (offset = 0) => {
    const { siteId, userId } = this.props;
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    api
      .get(
        `industrial/customer/v1/users/${userId}/contacts?contactType=PHONE&site-id=${siteId}`,
        parameters
      )
      .then((res) => {
        const response = res.data;
        if (response.length !== 0) {
          const newPhones = arrUniqueContact(response);
          this.setState({
            phones: newPhones,
            loading: false,
          });
        } else {
          this.props.dispatch(toggleStep(4));
        }
      })
      .catch((err) => {
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  };

  sendSmsCode = () => {
    const { contactName, contactId, userId } = this.props;
    if ((contactName, contactId)) {
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
      };
      const parameters = {
        method: 'POST',
        headers: header,
      };
      const body = {
        tokenType: 'ADD_CONTACT',
        contactId,
      };
      api
        .post(`industrial/customer/v1/users/${userId}/tokens`, body, parameters)
        .then((res) => {
          this.props.dispatch(toggleStep(3.1));
          toast.success(
            `Um código de SMS foi enviado para o telefone: ${contactName}`
          );
        })
        .catch((err) => {
          const { message } = err.response.data;
          if (message) {
            toast.error(message);
          } else {
            toast.error('Ocorreu um erro interno na aplicação');
            toast.error(
              'Certifique-se de estar conectado a internet ou tente novamente mais tarde!'
            );
          }
        });
    } else {
      this.props.dispatch(toggleStep(1));
    }
  };

  handleOffSet = () => {
    const { offset } = this.state;
    if (this.state.lastPage) {
      this.setState({ offset: offset - 1, lastPage: false });
    } else {
      this.setState({ offset: offset + 1 });
    }
    this.requestGetPhones(offset);
  };

  render() {
    const { props } = this;
    const { checkedId, contactSelected } = this.state;
    return (
      <FormBox>
        <Formik
          onSubmit={() => {
            this.selectedContact(contactSelected, checkedId);
          }}
          render={({ handleChange, handleBlur, values, errors, touched }) => (
            <>
              <FormHeader>
                <h2>
                  Selecione um celular para envio do <br />
{' '}
código de validação.
</h2>
              </FormHeader>
              <Form>
                <div className="container">
                  <div className="row">
                    <h4>Encontramos os seguintes:</h4>
                    <SelectPhoneContainer className="col-sm-12">
                      <div className="radio" style={{ marginBottom: 10 }}>
                        <label>
                          <input
                            type="radio"
                            value="option1"
                            checked={this.state.checkedId === null}
                            onClick={() => this.handleContactChange(null, null)}
                            style={{ marginRight: 10 }}
                          />
                          Nenhuma das opções
                        </label>
                      </div>
                      {this.state.phones.map((phones) => {
                        return (
                          <div
                            className="radio"
                            key={phones.contactId}
                            style={{ marginBottom: 10 }}
                          >
                            <label>
                              <input
                                type="radio"
                                value="option1"
                                onClick={() =>
                                  this.handleContactChange(
                                    phones.contact,
                                    phones.contactId
                                  )
                                }
                                name={phones.contactId}
                                id={phones.contactId}
                                style={{ marginRight: 10 }}
                                checked={
                                  this.state.checkedId === phones.contactId
                                }
                              />
                              {phones.contact}
                            </label>
                          </div>
                        );
                      })}
                    </SelectPhoneContainer>
                  </div>
                </div>
                <div style={{ marginTop: 50 }}>
                  <ContainedButton
                    className="mb-2"
                    block
                    continue
                    type="submit"
                    icon="arrow-right"
                    text="Continuar"
                    color="#288efd"
                    name="Continuar"
                    id="Continuar"
                    width="100%"
                    loading={this.state.loading}
                    TrailingIcon={() => <IoMdArrowForward size={20} />}
                  >
                    Continuar
                  </ContainedButton>
                  <OutlinedButton
                    onClick={() => this.props.dispatch(toggleStep(2))}
                    className="mb-2"
                    block
                    outline
                    icon="arrow-left"
                    text="Voltar"
                    color="#76d2e1"
                    name="Voltar"
                    id="Voltar"
                    width="100%"
                    LeadingIcon={() => <IoMdArrowBack size={20} />}
                  >
                    Voltar
                  </OutlinedButton>
                </div>
              </Form>
            </>
          )}
        />
      </FormBox>
    );
  }
}

const mapStateToProps = (state) => ({
  url: state.signUpReducer.url,
  document: state.signUpReducer.document,
  customerCode: state.signUpReducer.customerCode,
  contactName: state.signUpReducer.contactName,
  contactId: state.signUpReducer.contactId,
  siteId: state.signUpReducer.siteId,
  userId: state.signUpReducer.userId,
});

export default connect(mapStateToProps)(SignupComponent);
